import { RichText, MediaUpload, InspectorControls } from '@wordpress/block-editor';
import { Button, PanelBody, SelectControl } from '@wordpress/components';

wp.blocks.registerBlockType('meetravel/text-image', {
    title: 'Heading with Image',
    icon: 'layout',
    category: 'layout',
    editorStyle: "file:../../css/home/values-section.css",
    attributes: {
        sectionTitle: {
            type: 'string',
            source: 'html',
            selector: 'h2.section-title',
            default: 'Sei anche tu un MeeTraveller se condividi',
        },
        sectionDescription: {
            type: 'string',
            source: 'html',
            selector: 'h3.section-description',
            default: 'Descrizione con il fattore WOW (World Of Warcraft)',
        },
        imageUrl: {
            type: 'string',
            source: 'attribute',
            selector: 'img',
            attribute: 'src',
            default: '',
        },
        flexDirection: {
            type: 'string',
            default: 'row',
        },
    },

    edit(props) {
        function updateTextAttribute(attr, value) {
            props.setAttributes({ [attr]: value });
        }

        function onSelectImage(media) {
            props.setAttributes({ imageUrl: media.url });
        }

        function onChangeFlexDirection(value) {
            props.setAttributes({ flexDirection: value });
        }

        return (
            <>
                <InspectorControls>
                    <PanelBody title="Layout Settings" initialOpen={true}>
                        <SelectControl
                            label="Flexbox Orientation"
                            value={props.attributes.flexDirection}
                            options={[
                                { label: 'Row', value: 'row' },
                                { label: 'Column', value: 'column' },
                                { label: 'Row Reverse', value: 'row-reverse' },
                                { label: 'Column Reverse', value: 'column-reverse' },
                            ]}
                            onChange={onChangeFlexDirection}
                        />
                    </PanelBody>
                </InspectorControls>
                <section className="values-section">
                    <div className="content-wrap values-wrap" style={{ flexDirection: props.attributes.flexDirection }}>
                        <article className="values-text-article">
                            <header className="section-header">
                                <RichText
                                    tagName="h2"
                                    className="section-title"
                                    value={props.attributes.sectionTitle}
                                    onChange={(value) => updateTextAttribute('sectionTitle', value)}
                                    placeholder="Enter section title here"
                                />
                                <RichText
                                    tagName="h3"
                                    className="section-description"
                                    value={props.attributes.sectionDescription}
                                    onChange={(value) => updateTextAttribute('sectionDescription', value)}
                                    placeholder="Enter section description here"
                                />
                            </header>
                        </article>
                        <article className="value-image-article">
                            <div className="value-container">
                                <MediaUpload
                                    onSelect={onSelectImage}
                                    allowedTypes={['image']}
                                    render={({ open }) => (
                                        <Button onClick={open} className="button button-large">
                                            {!props.attributes.imageUrl ? 'Select Image' : <img src={props.attributes.imageUrl} alt='Value Image' />}
                                        </Button>
                                    )}
                                />
                            </div>
                        </article>
                    </div>
                </section>
            </>
        );
    },

    save(props) {
        return (
            <section className="values-section">
                <div className="content-wrap values-wrap" style={{ flexDirection: props.attributes.flexDirection }}>
                    <article className="values-text-article">
                        <header className="section-header">
                            <RichText.Content tagName="h2" className="section-title" value={props.attributes.sectionTitle} />
                            <RichText.Content tagName="h3" className="section-description" value={props.attributes.sectionDescription} />
                        </header>
                    </article>
                    <article className="value-image-article">
                        <div className="value-container">
                            <img src={props.attributes.imageUrl} alt='Value Image' />
                        </div>
                    </article>
                </div>
            </section>
        );
    },
});
